import Cookie from 'js-cookie';

import { AVAILABLE_LOCALES, DEFAULT_LOCALE } from 'localization/constants/configEnums';

export const getSneakerLocale = (): string => {
  const locale = Cookie.get('locale');
  return locale || AVAILABLE_LOCALES[DEFAULT_LOCALE].locale;
};
